import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'

export default {
  namespaced: true,

  state() {
    return {
      metrics: {},
    }
  },

  getters: {
    getMetricByPeriod: state => (period) => {
      return state.metrics?.[period] ?? 0;
    }
  },

  mutations: {
    setMetrics(state, metrics = {}) {
      state.metrics = metrics
    }
  },

  actions: {
    async fetchMetrics({ commit }, { scope, metricType, entityId, period }) {
      try {
        const response = await Api.Analytics.getMetrics(scope, metricType, entityId, period)
        if (response.status === 200) {
          commit('setMetrics', response.data.metrics)
        }
        return response.data
      } catch (error) {
        let err = Errors.create(error)
        commit('errors/add', err)
        throw err
      }
    }
  },
}